import React, { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { LargeButton, BaseDropdown } from "components/core";
import UploadFile from "components/UploadFile";
import { products, userplanIdFlex } from "utlis/utils";
import * as Styles from "pages/UploadPolicyDocument/styles";
import { Divider } from "@mui/material";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import PageHeader from "components/UniversalComponents/PageHeader";
import { WidthLimiter } from "pages/PlanSetup/styles";
import { theme } from "theme";
import http from "services/httpService";

const UploadPolicy = () => {
  const [documentId, setDocumentId] = useState();
  const [documentIdEmp, setDocumentIdEmp] = useState();
  const [selectedValue, setSelectedValue] = useState("");
  const [polDocName, setPolDocName] = useState("");
  const [benefitManual, setBenefitManual] = useState("");

  const navigate = useNavigate();
  const options = products();

  const savePlanIdAndNavigate = () => navigate("/v1/");

  const handleSubmit = async () => {
    // If both are undefined/null, alert
    if (!documentId && !documentIdEmp) {
      alert("Please upload at least one document.");
      return;
    }

    const userplan_id = userplanIdFlex(selectedValue);
    const payload = {
      userplan_id,
      ...(documentId && { employer_document_id: documentId }),
      ...(documentIdEmp && { employee_document_id: documentIdEmp }),
    };

    try {
      await http.post("/business/upload_policy_document/", payload);
      savePlanIdAndNavigate();
    } catch (ex) {
      console.log(ex?.response?.data);
      alert(ex);
    }
  };

  const getOptions = useCallback(
    () =>
      options.map((option) => ({
        ...option,
        title: option.label,
      })),
    [options]
  );

  return (
    <section>
      <WidthLimiter>
        <Formik
          initialValues={{ policy_type: "" }}
          validationSchema={Yup.object().shape({
            policy_type: Yup.string().required("*Required"),
          })}
          onSubmit={handleSubmit}
        >
          {(formikProps) => {
            const { values } = formikProps;
            setSelectedValue(values.policy_type);

            return (
              <Form>
                <PageHeader header="Upload Coverage Documents" />

                <div style={{ width: "50%", marginBottom: "2rem" }}>
                  <BaseDropdown
                    fontSize="14"
                    fontColor={theme.defaultFontColor}
                    label="Select Product"
                    options={getOptions()}
                    formikProps={{ ...formikProps, name: "policy_type" }}
                  />
                </div>

                <UploadFile
                  label="Policy Schedule for Employer"
                  text="Upload File"
                  format="pdf"
                  type="policy_document"
                  onSelect={setDocumentId}
                  existingFileName={polDocName}
                  bottom="-5rem"
                />

                <Divider />

                <UploadFile
                  label="Benefit Manual for Employees"
                  text="Upload PDF"
                  format="pdf"
                  type="policy_document"
                  onSelect={setDocumentIdEmp}
                  existingFileName={benefitManual}
                  bottom="-5rem"
                />

                <Styles.ButtonWrapper>

                  <LargeButton
                    id="business_about_next12"
                    textTransform="none"
                    label="Update"
                    type="submit"
                  opacity={!documentId && !documentIdEmp&&"60%"}
                    disabled={!documentId && !documentIdEmp}
                  />

                </Styles.ButtonWrapper>
              </Form>
            );
          }}
        </Formik>
      </WidthLimiter>
    </section>
  );
};

export default UploadPolicy;
